import Entity from 'txp-data/lib/schema/Entity';
import { trace } from 'owa-trace';
import logOwaDateError from './logOwaDateError';

export default function handleOwaDateError(e?: Error, entity?: Entity) {
    if (e && entity) {
        trace.error(
            `[handleOwaDateError]: ${e.message}, Entity Type: ${entity.entityType}, Template: ${
                entity.source
            }`
        );
        logOwaDateError(e, entity);
    }
}
